import * as constants from "./constants";
export const initialState = {
    //documents
    isLoading: false,
    data: [],
    error: null
};
const documentsReducer = (state = initialState, action)=> {
    switch (action.type) {
        case constants.DOCUMENTS_LIST_REQUESTING:
        case constants.PAGINATE_DOCUMENTS_LIST_REQUESTING:
            return {
                ...state,
                isLoading:true
            };

        case constants.DOCUMENTS_LIST_SUCCESS:
        case constants.PAGINATE_DOCUMENTS_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action?.payload,
                error: null,
            };

        case constants.DOCUMENTS_LIST_FAILED:
        case constants.PAGINATE_DOCUMENTS_LIST_FAILED:
            return {
                ...state,
                isLoading: false,
                data: [],
                error: action.error,
            };


        default:
            return state;
    }
}
export default documentsReducer
